import { render, staticRenderFns } from "./MenuToolbar.vue?vue&type=template&id=c4823d86&"
import script from "./MenuToolbar.vue?vue&type=script&lang=js&"
export * from "./MenuToolbar.vue?vue&type=script&lang=js&"
import style0 from "./MenuToolbar.vue?vue&type=style&index=0&id=c4823d86&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports